import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import { eventsRef,paymentsRef } from '../../firebase';

import Event from './Event';

import moment from 'moment';

const styles = theme => ({
  cll:{
    maxWidth:'50%',
    padding:'2%',
  },
    title: {
        paddingLeft: '2%',
        paddingRight: '5%',
        paddingTop: '2%',
        paddingBottom: '5rem',
    },
    button :{
        color:'#fff',
        background:'background-color: rgb(225, 0, 80)'
    },
     menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
    root: {
    flexGrow: 1,
  },
  flex: {
    flexGrow: 1,
  },
});

class Events extends Component {
    constructor(props) {
        super(props);


     
        eventsRef.where('refId', '==', this.props.myId).get()
            .then((querySnapshot) => {
                let data = [];

                querySnapshot.forEach((doc) => {
                    // doc.data() is never undefined for query doc snapshots
                    let eventData = {
                        id: doc.id,
                        data: doc.data(),
                    }
                    data.push(eventData);
                });

//console.log(data);
                data = data.sort((a, b) => {
                    return (moment(a.data.date, 'MM/DD/YYYY').isBefore(moment(b.data.date, 'MM/DD/YYYY')));
                })

                var currentEvents = [];
                var pastEvents = [];
                var raised;
                data.forEach(event => {
                    //console.log(event.id);
                    paymentsRef.where('eventId', '==', event.id).get()
                    .then((querySnapshot) => {

                        querySnapshot.forEach((doc) => {

                        var raised = doc.data().amount;
                        // console.log(doc.data().amount);

                        });
                    });

                    if (moment(event.data['date'], 'MM/DD/YYYY').isBefore()) {
                        pastEvents.push(event);
                    } else {
                        currentEvents.push(event);
                    }
                });
          
                console.log(raised);
 


                this.setState({
                    pastEvents,
                    currentEvents,
                    pastEventData: pastEvents,
                    currentEventData: currentEvents,
                    loading: false,
                });
            });


        this.state = {
            pastEventData: [],
            currentEventData: [],
            pastEvents: [],
            currentEvents: [],
            loading: true,
            searchText: '',
        }
    }

    searchFilter = text => {
        let searchTerm = text.target.value

        const { pastEvents, currentEvents } = this.state;

        let pastEventData = [];

        pastEvents.forEach(value => {
            let name = value.data.name;

            if (name.toLocaleLowerCase().startsWith(searchTerm.toLocaleLowerCase())) {
                pastEventData.push(value);
            }
        });

        let currentEventData= [];

        currentEvents.forEach(value => {
            let name = value.data.name;

            if (name.toLocaleLowerCase().startsWith(searchTerm.toLocaleLowerCase())) {
                currentEventData.push(value);
            }
        });

        this.setState({ 
            pastEventData,
            currentEventData,
            searchText: searchTerm,
        });
    }

    render() {
        const { classes } = this.props;

        if (this.state.loading) {
            return (
                <h2>Loading...</h2>
            );
        }

        if (this.state.pastEvents.length === 0) {
            return (
                <div className={classes.title}>
                    <h2>No events added yet</h2>
                    <Link to="/events/add" style={{ textDecoration: 'none' }}>
                        <Button variant="outlined">+ ADD NEW EVENT</Button>
                    </Link>
                </div>
            );
        }

        var searchBar;

        if(this.state.currentEvents.length !== 0 || this.state.pastEvents.length !== 0) {
            searchBar = (
                <div>
                    <TextField
                        value={this.state.searchText}
                        onChange={this.searchFilter}
                        style={{ paddingBottom: '10px', width: '80%' }}
                        label="Search"
                    />
                </div>
            )
        }

        return (
            <div className={classes.title}>
                {this.state.currentEvents.length === 0 && <h2>No events added yet</h2>}
                {searchBar}
                {this.state.currentEvents.length !== 0 &&
              
               <div className={classes.root}>
      <AppBar position="static">
        <Toolbar>
         
          <Typography variant="title" color="inherit" className={classes.flex}>
            Current Events
          </Typography>
          <Button variant="contained" color="secondary" href="/events/add" className={classes.button}>
        Host an Event
      </Button>
        </Toolbar>
      </AppBar>
        <Grid container>
                        {this.state.currentEventData.map((event) =>
                            <Grid container className={classes.cll} key={event.id} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Event data={event.data} id={event.id} bg={'#FFF'}/>
                            </Grid>
                        )}
                    </Grid>
    </div>
                }
             

                {this.state.pastEvents.length !== 0 &&
                <div className={classes.root}>
      <AppBar position="static">
        <Toolbar>
         
          <Typography variant="title" color="inherit" className={classes.flex}>
            Past Events
          </Typography>
      
        </Toolbar>
      </AppBar>
        <Grid container>
                        {this.state.pastEventData.map((event) =>
                            <Grid container key={event.id} className={classes.cll} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Event data={event.data} id={event.id} bg={'#AAA'}/>
                            </Grid>
                        )}
                    </Grid>
    </div>
                }
            </div>
        );
    }
}

Events.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Events);
    


// WEBPACK FOOTER //
// ./src/components/Events/Events.js